import request from '@/config/axios'

// ========== 枚举定义 ==========

/** 运势维度枚举（career=事业运势 love=爱情运势 health=健康状态 wealth=财富运势 overall=综合运势，流年断语用） */
export const ASTRO_DIMENSION_OPTIONS = [
  { value: 'career', label: '事业运势' },
  { value: 'love', label: '爱情运势' },
  { value: 'health', label: '健康状态' },
  { value: 'wealth', label: '财富运势' },
  { value: 'overall', label: '综合运势' }
] as const

/** 运势粒度枚举（day=每日 week=每周 year=每年/流年） */
export const ASTRO_GRANULARITY_OPTIONS = [
  { value: 'day', label: '每日' },
  { value: 'week', label: '每周' },
  { value: 'year', label: '每年' }
] as const

/** 运势档位 1-5（5 最好） */
export const ASTRO_BAND_OPTIONS = [1, 2, 3, 4, 5] as const

/** 运势维度 → 展示文案 */
export const ASTRO_DIMENSION_LABELS: Record<string, string> = {
  career: '事业运势',
  love: '爱情运势',
  health: '健康状态',
  wealth: '财富运势',
  overall: '综合运势'
}

/** 运势粒度 → 展示文案 */
export const ASTRO_GRANULARITY_LABELS: Record<string, string> = {
  day: '每日',
  week: '每周',
  year: '每年'
}

/** 星座元素 → el-tag 类型（火=danger 土=warning 风=primary 水=info） */
export const ELEMENT_TAG_TYPES: Record<string, 'danger' | 'warning' | 'primary' | 'info'> = {
  火: 'danger',
  土: 'warning',
  风: 'primary',
  水: 'info'
}

// ========== VO ==========

/** 星座档案 VO */
export interface ConstellationVO {
  id?: number
  name?: string
  /** 只读：日期区间（后端维护，不可改） */
  dateRange?: string
  /** 只读：元素（火/土/风/水，后端维护，不可改） */
  element?: string
  /** 只读：守护星（后端维护，不可改） */
  planet?: string
  personality?: string
  merit?: string
  attention?: string
  keywords?: string
  iconUrl?: string
  sort?: number
  status?: number
}

/** 星座档案更新 SaveReqVO（name/dateRange/element/planet 不可改，仅传可编辑字段） */
export interface ConstellationSaveReqVO {
  id: number
  personality?: string
  merit?: string
  attention?: string
  keywords?: string
  iconUrl?: string
  sort?: number
  status?: number
}

/** 星座精简信息 VO */
export interface ConstellationSimpleVO {
  id: number
  name: string
  iconUrl?: string
  status?: number
}

/** 运势模板 VO */
export interface AstroTemplateVO {
  id?: number
  dimension: string
  band: number
  granularity: string
  content: string
  sort?: number
  status?: number
}

// ========== 星座档案 ==========

export const ConstellationApi = {
  // 查询星座档案分页
  getPage: (params: PageParam) => {
    return request.get({ url: '/xuanxue/constellation/page', params })
  },
  // 查询星座档案详情（含全字段）
  get: (id: number) => {
    return request.get({ url: '/xuanxue/constellation/get?id=' + id })
  },
  // 修改星座档案（仅可编辑字段：personality/merit/attention/keywords/iconUrl/sort/status）
  update: (data: ConstellationSaveReqVO) => {
    return request.put({ url: '/xuanxue/constellation/update', data })
  },
  // 修改星座档案状态
  updateStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/constellation/update-status', params: { id, status } })
  },
  // 获取星座精简列表
  getSimpleList: async (): Promise<ConstellationSimpleVO[]> => {
    return await request.get({ url: '/xuanxue/constellation/simple-list' })
  }
}

// ========== 运势模板 ==========

export const AstroTemplateApi = {
  // 查询运势模板分页
  getPage: (params: PageParam) => {
    return request.get({ url: '/xuanxue/astro-template/page', params })
  },
  // 新增运势模板
  create: (data: AstroTemplateVO) => {
    return request.post({ url: '/xuanxue/astro-template/create', data })
  },
  // 修改运势模板
  update: (data: AstroTemplateVO) => {
    return request.put({ url: '/xuanxue/astro-template/update', data })
  },
  // 修改运势模板状态
  updateStatus: (id: number, status: number) => {
    return request.put({ url: '/xuanxue/astro-template/update-status', params: { id, status } })
  },
  // 删除运势模板
  delete: (id: number) => {
    return request.delete({ url: '/xuanxue/astro-template/delete?id=' + id })
  }
}
